import { Injectable, inject } from '@angular/core'
import { environment } from '../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { UtopSettings } from './utop-settings'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends RestClientPaged<UtopSettings, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/settings', http, {})
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public getSettings(): Observable<UtopSettings[]> {
    return this.http.get<UtopSettings[]>(environment.apiPath + '/settings')
  }

  public updateSettings(update: UtopSettings): Observable<UtopSettings> {
    return this.http.post<UtopSettings>(environment.apiPath + '/settings', update)
  }
}
